import { useEffect, useState, useRef } from "react";

import { getList } from "services/api/Api";
import { showTitle } from "@util/Scripts";
import {
   Icon_MessageOpen,
   Icon_ArrowRight2,
   Icon_Dot,
   Icon_NoData,
} from "../../BP2Components/Icons/icons";
import InformationListModal from "../WidgetsSettings/InformationList/InformationListSettingsModal";
import SettingsModal from "../../Modal/SettingsModal";
import Widget from "../../Widget/Widget";
import { Spin, Modal, Message, Empty } from "../../BP2Components";
import { getForm, saveFormV2 } from "../../../services/restAPI/RestApi";
import { ListScripts } from "../ListWidget/Lists/listScripts";

import "./informationList.less";
import { useIntl } from "react-intl";

const InformationListWidget = ({ value, role, data }) => {
   const [rows, setRows] = useState([]);
   const [columns, setColumns] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const [loading, setLoading] = useState(true);
   const [metaData, setMetaData] = useState([]);
   const [listResponse, setListResponse] = useState(null);
   const [contentModalOpen, setContentModalOpen] = useState(null);
   const [modalContent, setModalContent] = useState(null);
   const [modalLoading, setModalLoading] = useState(false);
   const i = useIntl();

   const newsListRef = useRef();

   value.itemsPerPage = parseInt(value?.itemsPerPage) || 20;

   const handleListResponse = (res) => {
      const columnsCopy = [];
      const responseData = res?.data?.default;

      setListResponse(responseData);

      responseData.columns.map((column) => {
         if (
            (column.options.visible == "1" || column.options.resolver) &&
            column.options.techName
         ) {
            columnsCopy.push({
               title: column?.label,
               dataIndex: column?.label,
               techName: column?.options?.techName,
               precision: column?.options?.precision,
            });
         }
         return null;
      });

      setMetaData(responseData?.meta);

      let rowsTable = responseData.data.map((row, i) => {
         const obj = {};
         columnsCopy.forEach((column) => {
            if (typeof row[column.dataIndex] === "string") {
               let rowValue = Number(row[column.dataIndex]);
               // This has to check if rowValue is an empty string or not, because Number() makes converts empty string to 0
               if (
                  row[column.dataIndex] &&
                  column.precision &&
                  row[column.dataIndex].length > 0 &&
                  !isNaN(rowValue)
               ) {
                  obj[column.dataIndex] = rowValue.toFixed(column.precision).toString();
               } else {
                  obj[column.dataIndex] = row[column.dataIndex];
               }
            } else {
               obj[column.dataIndex] = row[column.dataIndex];
            }
         });
         obj.api_rowMetaData = { recordId: row?.api_rowMetaData?.recordId };
         obj.key = i;
         return obj;
      });

      setColumns(columnsCopy);
      setRows(rowsTable);
      setLoading(false);
   };

   useEffect(() => {
      if (value && value?.listId) {
         getList(value?.listId, currentPage, value?.itemsPerPage).then(handleListResponse);
      }
   }, [value, currentPage]);

   const handlePageChange = (page) => {
      setLoading(true);
      setCurrentPage(page);
   };

   const handleNewsClick = (i, isReadTechname, recordId, contentHTML, title, date) => {
      setModalContent(null);
      setContentModalOpen(true);
      setModalLoading(true);
      getForm(listResponse?.actions[0]?.formID, recordId).then((resp) => {
         const mainForm = resp?.data?.default?.mainForm;
         const formKey = mainForm?._formKey;
         const fields = mainForm?.forms_data?.tab?.[0]?.elements;
         let currContent = "";

         const formValues = {};
         Object.keys(fields).forEach((key) => {
            const currField = fields[key];
            const respValue = currField?.value;
            if (respValue?.value) {
               formValues[currField?.tech_name] = respValue?.value;
            } else {
               formValues[currField?.tech_name] = respValue;
            }
            if (currField.tech_name === "contents") {
               currContent = currField?.value;
            }
         });
         formValues[isReadTechname] = "1";

         saveFormV2(
            listResponse?.actions[0]?.formID,
            formKey,
            formValues,
            recordId,
            null,
            undefined,
         );
         setModalContent({ content: currContent, title: title, date: date });
         setModalLoading(false);
         const titleContainer = document.getElementById(`info_${i}_${recordId}`);
         titleContainer.classList.remove("unread-true");
         titleContainer.classList.add("unread-false");
      });
   };

   const isRead = (isReadColumnTechName, row) => {
      let read = false;
      if (
         isReadColumnTechName &&
         listResponse?.columns &&
         ListScripts.getLabelByTechname(isReadColumnTechName, listResponse.columns)
      ) {
         const readInfo =
            row?.[ListScripts.getLabelByTechname(isReadColumnTechName, listResponse.columns)];
         read = readInfo?.includes("1") ? true : false;
      }
      return read;
   };

   return (
      <Widget
         title={showTitle(value.title, "", data)}
         styleName="gx-card-profile-sm"
         bgColor={value.backgroundColourHex}
         className={`${value?.hideWidgetBorder && "hidden-widget-background"}`}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={value.name}
                  widgetId={value.id}
                  icon="setting"
                  deleteIcon="true"
                  children={
                     <InformationListModal
                        value={value}
                        columns={columns}
                        rows={rows}
                        data={data}
                     />
                  }
               />
            )
         }
      >
         <div
            ref={newsListRef}
            className={`informationList-container ${
               value?.hideWidgetBorder && "hidden-widget-background"
            }`}
         >
            <div className="information-item-container">
               {loading ? (
                  <Spin />
               ) : rows.length === 0 ? (
                  <Empty description={i.formatMessage({ id: "list.noData" })} />
               ) : (
                  rows.map((row, index) => (
                     <div
                        className="information-container"
                        onClick={() => {
                           if (
                              ListScripts.getLabelByTechname(
                                 value?.isReadColumnTechName,
                                 listResponse?.columns,
                              )
                           ) {
                              handleNewsClick(
                                 index,
                                 value?.isReadColumnTechName,
                                 row?.api_rowMetaData?.recordId,
                                 row?.[
                                    ListScripts.getLabelByTechname(
                                       value.contentColumnTechName,
                                       listResponse.columns,
                                    )
                                 ] || "",
                                 row?.[
                                    ListScripts.getLabelByTechname(
                                       value.titleColumnTechName,
                                       listResponse.columns,
                                    )
                                 ] || "",
                                 row?.[
                                    ListScripts.getLabelByTechname(
                                       value.dataColumnTechName,
                                       listResponse.columns,
                                    )
                                 ] || "",
                              );
                           }
                        }}
                        key={row.key}
                     >
                        <div className="info-cover-container">
                           {value?.photoColumnTechName &&
                           listResponse?.columns &&
                           ListScripts.getLabelByTechname(
                              value.photoColumnTechName,
                              listResponse.columns,
                           ) ? (
                              <img
                                 src={
                                    row[
                                       ListScripts.getLabelByTechname(
                                          value.photoColumnTechName,
                                          listResponse.columns,
                                       )
                                    ]
                                 }
                              />
                           ) : null}
                        </div>
                        <div className="info-info-container">
                           <div className="info-info-left">
                              <div className="info-info-header">
                                 <Icon_MessageOpen className="header-date" />
                                 {value?.authorColumnTechName &&
                                 listResponse?.columns &&
                                 ListScripts.getLabelByTechname(
                                    value.authorColumnTechName,
                                    listResponse.columns,
                                 ) &&
                                 typeof row?.[
                                    ListScripts.getLabelByTechname(
                                       value.authorColumnTechName,
                                       listResponse.columns,
                                    )
                                 ] === "object" ? (
                                    <span className="author-in-header">
                                       {
                                          row?.[
                                             ListScripts.getLabelByTechname(
                                                value.authorColumnTechName,
                                                listResponse.columns,
                                             )
                                          ]?.value
                                       }
                                    </span>
                                 ) : null}
                                 {value?.dataColumnTechName &&
                                 listResponse?.columns &&
                                 ListScripts.getLabelByTechname(
                                    value.dataColumnTechName,
                                    listResponse.columns,
                                 ) ? (
                                    <span className="date-in-header gx-pl-2">
                                       {
                                          row?.[
                                             ListScripts.getLabelByTechname(
                                                value.dataColumnTechName,
                                                listResponse.columns,
                                             )
                                          ]
                                       }
                                    </span>
                                 ) : null}
                              </div>
                              <div
                                 id={`info_${index}_${row?.api_rowMetaData?.recordId}`}
                                 className={`info-info-title unread-${!isRead(
                                    value?.isReadColumnTechName,
                                    row,
                                 )}`}
                              >
                                 {value?.titleColumnTechName &&
                                 listResponse?.columns &&
                                 ListScripts.getLabelByTechname(
                                    value.titleColumnTechName,
                                    listResponse.columns,
                                 ) ? (
                                    <>
                                       <Icon_Dot
                                          className="unread-icon"
                                          style={
                                             isRead(value?.isReadColumnTechName, row)
                                                ? { display: "none" }
                                                : {}
                                          }
                                          fill="var(--btn-primaryBackground)"
                                       />
                                       {
                                          row?.[
                                             ListScripts.getLabelByTechname(
                                                value.titleColumnTechName,
                                                listResponse.columns,
                                             )
                                          ]
                                       }
                                    </>
                                 ) : null}
                              </div>
                           </div>
                           <div className="info-info-right">
                              <Icon_ArrowRight2 />
                           </div>
                        </div>
                     </div>
                  ))
               )}
            </div>
            {/* <div className="pagination-container gx-pt-1">
               {loading ? (
                  <div id="items-loader" className="items-loader">
                     <Spin />
                  </div>
               ) : metaData?.totalPages > 1 ? (
                  <Pagination
                     defaultPageSize={value?.itemsPerPage}
                     onChange={(page) => handlePageChange(page)}
                     totalItems={metaData.totalItemsCount}
                     initialPage={currentPage}
                  />
               ) : null}
            </div> */}
         </div>

         <Modal
            topBarContent={!!modalContent ? `${modalContent?.title} - ${modalContent?.date}` : ""}
            isOpen={contentModalOpen}
            width={window?.innerWidth > 1000 ? window?.innerWidth / 2 : "100%"}
            height={window?.innerHeight / 1.5}
            onCancel={() => setContentModalOpen(false)}
         >
            {modalLoading ? (
               <Spin />
            ) : (
               <div className="html-content-container">
                  <div dangerouslySetInnerHTML={{ __html: modalContent?.content || "" }} />
               </div>
            )}
         </Modal>
      </Widget>
   );
};

export default InformationListWidget;
